import React from 'react'
import PropTypes from 'prop-types'

// FA Free has no bell-with-sound-waves equivalent, so this is hand-rolled.
const PATH_D = 'M9.14205 17.082C11.0401 17.3071 12.958 17.3071 14.856 17.082C16.7192 16.8614 18.5499 '
  + '16.4217 20.31 15.772C18.8194 14.1208 17.9958 11.9745 17.999 9.75V9C17.999 7.4087 17.3669 5.88258 '
  + '16.2417 4.75736C15.1165 3.63214 13.5903 3 11.999 3C10.4077 3 8.88162 3.63214 7.75641 4.75736C6.63119 '
  + '5.88258 5.99905 7.4087 5.99905 9V9.75C6.00206 11.9746 5.17803 14.121 3.68705 15.772C5.42005 16.412 '
  + '7.24705 16.857 9.14205 17.082ZM14.856 17.082C15.0001 17.5319 15.036 18.0094 14.9606 '
  + '18.4757C14.8853 18.942 14.7009 19.384 14.4224 19.7656C14.144 20.1472 13.7794 20.4576 13.3582 '
  + '20.6716C12.9371 20.8856 12.4714 20.9972 11.999 20.9972C11.5267 20.9972 11.061 20.8856 10.6399 '
  + '20.6716C10.2187 20.4576 9.85412 20.1472 9.57567 19.7656C9.29722 19.384 9.11281 18.942 9.03746 '
  + '18.4757C8.96211 18.0094 8.99794 17.5319 9.14205 17.082M3.12305 7.5C3.40502 5.82497 4.15684 4.26444 '
  + '5.29105 3M18.707 3C19.8413 4.26444 20.5931 5.82497 20.875 7.5'

const BellOnIcon = ({ className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    height="1em"
    viewBox="0 0 24 24"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d={PATH_D}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
)

BellOnIcon.propTypes = {
  className: PropTypes.string
}

BellOnIcon.defaultProps = {
  className: ''
}

export default BellOnIcon
